module.exports = __webpack_public_path__ + "img/GE.f8e8ff98.svg";